module.exports = __webpack_public_path__ + "img/optionA.9d7b6c86.png";